import CategoryPage from '../category_page';
import categoryPageStateManager from '../category_page_state_manager';

export default function(store) {
  return {
    path: '/category/:category/:page',
    component: CategoryPage,
    exact: true,
    strict: true,
    loadData: categoryPageStateManager(store)
  };
}
